export const getParamKey = (id: string) => `_${id}`;
